import { render, staticRenderFns } from "./ModalCarrinho.vue?vue&type=template&id=bc331d6a&scoped=true"
import script from "./ModalCarrinho.vue?vue&type=script&lang=js"
export * from "./ModalCarrinho.vue?vue&type=script&lang=js"
import style0 from "./ModalCarrinho.vue?vue&type=style&index=0&id=bc331d6a&prod&lang=scss&scoped=true"
import style1 from "./ModalCarrinho.vue?vue&type=style&index=1&id=bc331d6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc331d6a",
  null
  
)

export default component.exports